// extracted by mini-css-extract-plugin
export var button = "componentMedia-module--button--fc6c8";
export var cafeFormIntro = "componentMedia-module--cafe-form-intro--08119";
export var desc = "componentMedia-module--desc--429eb";
export var highlight = "componentMedia-module--highlight--9ca52";
export var imageCaption = "componentMedia-module--image-caption--eaa32";
export var mobilePhoto = "componentMedia-module--mobile-photo--b90f7";
export var photo = "componentMedia-module--photo--4f1e5";
export var reactPlayer = "componentMedia-module--react-player--75d1b";
export var redButton = "componentMedia-module--red-button--73150";
export var redTransparentButton = "componentMedia-module--red-transparent-button--8efc4";
export var spacedWrapper = "componentMedia-module--spaced-wrapper--6ba59";
export var title = "componentMedia-module--title--0201e";
export var transparentButton = "componentMedia-module--transparent-button--864b5";
export var videoBg = "componentMedia-module--video-bg--595e3";
export var videoWrapper = "componentMedia-module--videoWrapper--5514d";